// Pathify
import { make } from 'vuex-pathify'
import axios from 'axios'
import auth from './authentification'
import message from './messages'

const state = {
  dataReceptionProvinceList: [],
  planDeadline: '',
  needs: [],
  planSelectedPicture: [],
  planSelectedDocument: []
}

const mutations = {
  setDataReceptionProvinceList(state, payload) {
    state.dataReceptionProvinceList = payload;
  },
  setPlanDeadline(state, payload) {
    state.planDeadline = payload;
  },
  setNeeds(state, payload) {
    state.needs = payload;
  },
  setPlanSelectedPicture(state, payload) {
   state.planSelectedPicture = payload;
  },
  setPlanSelectedDocument(state, payload) {
   state.planSelectedDocument = payload;
  },
  /*setConfirmationAdd(state, payload) {
   message.state.confirmationMessageAdd = payload;
  },
  setConfirmationUpdate(state, payload) {
   message.state.confirmationMessageUpdate = payload;
  },
  setConfirmationDelete(state, payload) {
   message.state.confirmationMessageDelete = payload;
  },
  setErrorMessage(state, payload) {
   message.state.errorMessage = payload;
  }*/
}

const actions = {
  getPlanSelectedSinglePicture: ({ state, commit, dispatch }, payload) => {

    state.planSelectedPicture = [];

    try{

      for(var i=0; i < payload.length; i++){

        axios.post(`/api/project_need_single_picture`,payload[i]).then(response => {
            state.planSelectedPicture.push(response.data);

            //console.log('STORE state.planSelectedPicture', state.planSelectedPicture);
          });

      }
    } catch(error){
      commit('setPlanSelectedPicture', []);
    }

  },
  /*getPlanSelectedPicture: ({ state, commit, dispatch }, payload) => {
    try{
      axios.post(`/api/project_need_picture`,payload).then(response => {
        commit('setPlanSelectedPicture', response.data);
      });
    } catch(error){
      commit('setPlanSelectedPicture', []);
    }
  },*/
  getPlanSelectedDocument: ({ state, commit, dispatch }, payload) => {
    try{
      axios.post(`/api/project_need_document`,payload).then(response => {
        commit('setPlanSelectedDocument', response.data);
      });
    } catch(error){
      commit('setPlanSelectedDocument', []);
    }
  },
  getDataReceptionProvinceList: ({ state, commit }) => {
    try{
      axios.get(`/api/data_reception_province_list`).then(response => {
        commit('setDataReceptionProvinceList', response.data);
      });
    } catch(error){
      commit('setDataReceptionProvinceList', []);
    }
  },
  getPlanDeadline: ({ state, commit }) => {
    try{
      axios.get(`/api/plan_deadline`).then(response => {
        commit('setPlanDeadline', response.data[0].plan_deadline);
      });
    } catch(error){
      commit('setPlanDeadline', []);
    }
  },
  updatePlanDealine: ({ state, commit, dispatch }, payload) => {
    try{

      var request = {
        deadline: payload,
        username : auth.state.username
      }

      //axios.post(`/api/update_plan_deadline`,{'deadline': payload }).then(response => {
      axios.post(`/api/update_plan_deadline`,request).then(response => {

        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('getPlanDeadline');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setPlanDeadline', []);
    }
  },
  addNeed: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      //axios.post(`/api/new_need`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {
      axios.post(`/api/new_need`,payload).then(response => {

        message.mutations.setConfirmationAdd(message.state, true);

        payload.project_need_id = response.data.id;

        if(payload.project_need_pictures && payload.project_need_pictures.length !== 0){

          dispatch('addNeedPictures',payload);
        }

        if(payload.new_project_need_documents && payload.new_project_need_documents.length !== 0){

          dispatch('addNeedDocuments',payload);
        }

        dispatch('getNeeds');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setNeeds', []);
    }
  },
  addNeedPictures: ({ state, commit, dispatch }, payload) => {
    try{

      axios.post(`/api/new_need_pictures`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {
        dispatch('getNeeds');
      });
    } catch(error){
      commit('setNeeds', []);
    }
  },
  addNeedDocuments: ({ state, commit, dispatch }, payload) => {
    try{
      
      axios.post(`/api/new_need_documents`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {
        dispatch('getNeeds');
      });
    } catch(error){
      commit('setNeeds', []);
    }
  },

  getNeeds: ({ state, commit }) => {

    var user_parameter = {};

    if(auth.state.user.user_profile_id === 3){
        user_parameter.province_id = auth.state.user.province_id;
        user_parameter.project_owner_id = auth.state.user.project_owner_id;
    }else if(auth.state.user.user_profile_id === 2){
        user_parameter.province_id = auth.state.user.province_id;
    }

    try{
        axios.post(`/api/need_list`,user_parameter).then(response => {
          //console.log('****get needs', response.data);
        commit('setNeeds', response.data);
      });
    } catch(error){
      commit('setNeeds', []);
    }
  },
 updateNeed: ({ state, commit, dispatch }, payload) => {
    try{

      payload.username = auth.state.username;

      axios.post(`/api/update_need`,payload, { headers: { "Content-Type": "multipart/form-data"}}).then(response => {

        message.mutations.setConfirmationUpdate(message.state, true);
        dispatch('getNeeds');
      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setNeeds', []);
    }
  },
  deleteNeed: ({ state, commit, dispatch }, payload) => {
    try{

      var request = {
        id: payload,
        username : auth.state.username
      }

      //axios.post(`/api/delete_need`,{id: payload}).then(response => {
      axios.post(`/api/delete_need`,request).then(response => {

        message.mutations.setConfirmationDelete(message.state, true);
        dispatch('getNeeds');

      });
    } catch(error){
      message.mutations.setErrorMessage(message.state, true);
      commit('setNeeds', []);
    }
  },
  downloadPlanImg: ({ state, commit, dispatch }, payload) => {

    //https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript
    if(payload.file){
      var bytes = new Uint8Array(payload.file.data); // pass your byte response to this constructor
      var blob_type = payload.mimetype;
      var blob=new Blob([bytes], {type: blob_type});// change resultByte to bytes

      var link=document.createElement('a');
      link.href=window.URL.createObjectURL(blob);
      link.download=payload.original_name;
      link.click();
    }

  },
  downloadPlanDocument: ({ state, commit, dispatch }, payload) => {
    try{

      axios.post(`/api/download_plan_document`,payload).then(response => {
        //https://stackoverflow.com/questions/35038884/download-file-from-bytes-in-javascript
        if(response.data.file){
          var bytes = new Uint8Array(response.data.file.data); // pass your byte response to this constructor
          var blob_type = response.data.mimetype;
          var blob=new Blob([bytes], {type: blob_type});// change resultByte to bytes

          var link=document.createElement('a');
          link.href=window.URL.createObjectURL(blob);
          link.download=response.data.original_name;
          link.click();
        }

      });
    } catch(error){
      commit('getProjectOnGoingList', []);
    }
  },
  deletePlanImg: ({ state, commit, dispatch }, payload) => {
    try{

      var request = {
        id: payload.id,
        username : auth.state.username
      }

      //axios.post(`/api/delete_plan_img`,{id: payload.id}).then(response => {
      axios.post(`/api/delete_plan_img`,request).then(response => {
        //dispatch('getPlanSelectedPicture',{project_need_id: payload.project_need_id});
        state.planSelectedPicture = state.planSelectedPicture.filter(img => img[0].id != request.id);
      });
    } catch(error){
      commit('setPlanSelectedPicture', []);
    }
  },
  deletePlanDocument: ({ state, commit, dispatch }, payload) => {
    try{

      var request = {
        id: payload.id,
        username : auth.state.username
      }

      //axios.post(`/api/delete_plan_document`,{id: payload.id}).then(response => {
      axios.post(`/api/delete_plan_document`,request).then(response => {
        dispatch('getPlanSelectedDocument',{project_need_id: payload.project_need_id});
      });
    } catch(error){
      commit('setNeeds', []);
    }
  },
}

const getters = {
  planDeadline: state => {
    return state.planDeadline
  },
  needs: state => {
    return state.needs
  },
  planSelectedPicture: state => {
    return state.planSelectedPicture
  },
  planSelectedDocument: state => {
    return state.planSelectedDocument
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
